/**
 * Route paths for mops-web. Admin tool paths are added incrementally as each
 * tool migrates from `@orn/web` — see the batched migration strategy under
 * ORN-526.
 */
export const PATHS = {
  HOME: '/',
  ALPHA_ALLOW_LIST: '/alpha-allow-list',
  BANK_CONNECTIONS: '/bank-connections',
  BILL_MANAGEMENT: '/bill-management',
  FEATURE_GATES: '/feature-gates',
  /** Detail route for editing an existing gate by id. */
  FEATURE_GATE_EDIT: '/feature-gates/:id',
  /** New-gate creation form — flat path, kept in sync with the list view. */
  FEATURE_GATE_NEW: '/feature-gates/new',
  IMPERSONATE_USER: '/impersonate-user',
  PROCESSOR_STATUSES: '/processor-statuses',
  RELEASES: '/releases',
  TRANSACTION_ANOMALY_FEEDBACK: '/transaction-anomaly-feedback',
  /** Pattern for the per-user detail route — consumed by the React Router definition. */
  TRANSACTION_ANOMALY_FEEDBACK_FOR_USER: '/transaction-anomaly-feedback/:userId',
} as const;

export type PathKey = keyof typeof PATHS;
export type PathValue = (typeof PATHS)[PathKey];

/** Builds the URL for the per-user transaction anomaly feedback detail scene. */
export function transactionAnomalyFeedbackForUserPath(userId: string): string {
  return `/transaction-anomaly-feedback/${userId}`;
}

/** Builds the URL for editing a feature gate by id. */
export function featureGateEditPath(id: string): string {
  return `/feature-gates/${id}`;
}
